export function IconTile({ icon, className = '' }: { icon: string; className?: string }) {
  return (
    <span
      className={`d-inline-flex align-items-center justify-content-center rounded-3 bg-surface-high text-primary flex-shrink-0 ${className}`}
      style={{ width: 40, height: 40 }}
    >
      <i className={`bi ${icon} fs-5`} />
    </span>
  );
}